import { render, staticRenderFns } from "./DeliveryLog.vue?vue&type=template&id=7a8853fe"
import script from "./DeliveryLog.vue?vue&type=script&lang=js"
export * from "./DeliveryLog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryLog.vue?vue&type=style&index=0&id=7a8853fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports